import { AfterContentInit, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable, combineLatest, filter, map, of, switchMap, take } from 'rxjs';
import { ClientDetailsResponse } from 'src/app/account/my-account/model/agentDetailsResponse.model';
import { HelpSourceTypeService } from 'src/app/services/help-source-type.service';
import { UserService } from 'src/app/services/shared/user.service';

export interface supportSharedData {
    previousUrl?: string;
    issueInput?: string;
    sourceType?: string;
  }

declare var hbspt: any;
@Component({
  selector: 'terra-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportComponent implements OnInit, AfterContentInit {  
  previousUrl = '';
  sharedData: supportSharedData

  isLoggedIn$ = this.userService.isLoggedIn$;

  accountDetails$: Observable<ClientDetailsResponse>= this.isLoggedIn$.pipe(
    filter(isLoggedIn => !!isLoggedIn),
    switchMap(_ => this.userService.accountDetails$),
  );

  isAgent$ = this.accountDetails$.pipe(
    map(accountDetails => accountDetails.isAgent)
  );

  isLp$ = this.accountDetails$.pipe(
    map(accountDetails => !accountDetails.isAgent)
  );

  constructor(
    private userService: UserService,
    private sourceTypeService: HelpSourceTypeService
  ) {}

  ngOnInit(): void {
    const sharedData = window.opener?.sharedData;
    if (sharedData) {
      this.sharedData = sharedData;
    }
  }

  ngAfterContentInit() {
    const sourceType$ = this.sourceTypeService.sourceType$;
    const issueInput$ = this.sourceTypeService.issueInput$;
    const accountDetails$ = this.accountDetails$;

    hbspt.forms.create({
      portalId: "2927640",
      formId: "5b87d8d5-010a-4050-a345-0b032686101a",
      target: "#hubspotForm",
      onFormReady: ($form) => {
       
        const triggerEvent = new Event("input", { bubbles: true });
        combineLatest([sourceType$, accountDetails$, issueInput$, of(this.sharedData)])
        .pipe(
          take(1)
        )
        .subscribe(([sourceType, accountDetails, issueInput, sharedData]) => {
            if($form){
              $form.querySelector('input[name="firstname"]').value = accountDetails.firstName;
              $form.querySelector('input[name="firstname"]').dispatchEvent(triggerEvent);

              $form.querySelector('input[name="lastname"]').value = accountDetails.lastName;
              $form.querySelector('input[name="lastname"]').dispatchEvent(triggerEvent);
             
              $form.querySelector('input[name="email"]').value = accountDetails.email;
              $form.querySelector('input[name="email"]').dispatchEvent(triggerEvent);

              $form.querySelector('input[name="phone"]').value = accountDetails.phone1;
              $form.querySelector('input[name="phone"]').dispatchEvent(triggerEvent);

              if(sharedData?.issueInput){
                $form.querySelector('input[name="TICKET.subject"]').value = sharedData.issueInput;
                $form.querySelector('input[name="TICKET.subject"]').dispatchEvent(triggerEvent);
              }

              if(issueInput){
                $form.querySelector('input[name="TICKET.subject"]').value = issueInput;
                $form.querySelector('input[name="TICKET.subject"]').dispatchEvent(triggerEvent);
              }

              if(sharedData?.sourceType){
                $form.querySelector('input[name="TICKET.source_type"]').value = sharedData.sourceType;
                $form.querySelector('input[name="TICKET.source_type"]').dispatchEvent(triggerEvent);
              }

              if(sourceType){
                $form.querySelector('input[name="TICKET.source_type"]').value = sourceType;
                $form.querySelector('input[name="TICKET.source_type"]').dispatchEvent(triggerEvent);
              }
            }
          });
      }
    });
  }

}
